import { render } from "./ECheckForm.vue?vue&type=template&id=1723b43a"
import script from "./ECheckForm.vue?vue&type=script&lang=ts"
export * from "./ECheckForm.vue?vue&type=script&lang=ts"
script.render = render

export default script